enum TourOrganizerInsurance {
  NONE = 'NONE',
}

export default TourOrganizerInsurance;
